import React from "react";
import VehicleForm from "./components/Vehicle/VehicleForm";
import JobForm from "./components/Job/JobForm";
import QuoteForm from "./components/Quote/QuoteForm";
import Home from "./components/Homepage/Home";
import RentalForm from "./components/Rentals/RentalForm";
import RentalPrintView from "./components/Rentals/PrintView";
import Vehicles from "./components/Vehicle/View/VehiclesView";
import Settings from "./components/Settings/Settings";
import Jobs from "./components/Job/View";
import Quotes from "./components/Quote/View";
import Rentals from "./components/Rentals/View";
import { Container, Section } from "@allxsmith/bestax-bulma";
import Contact from "./components/Contact/Form";
import Contacts from "./components/Contact/View";
import Diary from "./components/Diary/View";
import axios from "axios";

import {Route, Navigate, BrowserRouter, Routes} from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import PartHistory from "./components/PartHistory/PartHistory";
import PartLookup from "./components/PartLookup/PartLookup";
import Inspection from "./components/Inspections/View";
import Payment from "./components/Payment/View";
import { Component } from "react";
import Spinner from "react-spinner-material";
import GoogleLoginButton from "./components/GoogleLogin";
import Transactions from "./components/Transactions/Transactions";
import Reports from "./components/Reports/View";
import WorkLookup from "./components/WorkLookup/WorkLookup";
import VehicleTrackers from "./components/Tracker/VehicleTrackers";
import RecurringPayment from "./components/RecurringPayment/RecurringPayment";
import DefectForm from "./components/Job/Defects/DefectForm";
import ContactsAccountBalance from "./components/Contact/ContactsAccountBalance";
import WorkLookupForm from "./components/WorkLookup/WorkLookupForm";
import PartEnquiryForm from "./components/Job/Part Enquiry/Form";
import MovementView from "./components/Movement/View";
import KeyFinder from "./components/Vehicle/KeyFinder/Keyfinder";
import InvoiceView from "./components/Movement/Invoicing/InvoiceView";
import CreditView from "./components/Credit Note/View";
import FixedExpense from "./components/FixedExpense/FixedExpense";
import PartOrderView from "./components/PartOrder/View";
import PartOrderForm from "./components/PartOrder/PartOrderForm";
import AllDropDownLinks from "./components/Nav/AllDropDownLinks";
import PartView from "./components/Part/PartView";
import InvoicePOView from "./components/Invoicing/InvoicePOView";
import MovementForm from "./components/Movement/MovementForm";
import VanPartsExpenses from "./components/VanPartsExpenses/View";
import LabelPrinterPage from "./components/PartOrder/LabelPrinterPage";
import VanPartsIncome from "./components/VanPartsIncome/View";
import {Outlet} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";


const routeProps = { endpoint: "/api/" };

function PrivateRoute() {
  if(!localStorage.token) {
    return  <Navigate to={{pathname: "/login"}} replace/>;
  }

  return <Outlet/>;
}

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: 0
    };
  }

  UNSAFE_componentWillMount() {
    axios.interceptors.request.use(function(config) {
      const token = localStorage.getItem("token");
      config.headers.Authorization = `Token ${token}`;
      return config;
    });

    axios.interceptors.response.use(
      response => {
        if (response.status === 401) {
          window.location.href = "/login";
        }
        // If the request succeeds, we don't have to do anything and just return the response
        // Lock heartbeat/acquire/release POSTs are silent background calls - they must not
        // raise a "Data saved successfully" toast (otherwise an idle open order toasts every 60s).
        const _silent = (response.config.url || "").indexOf("/lock") !== -1;
        if (response.config.method !== "get" && !_silent) {
          // NotificationManager.success("Data saved successfully.", "Success!");
          toast.success("Data saved successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          })
        }
        return response;
      },
      response => {
        toast.error("Error", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          })
        return Promise.reject(response);
      }
    );
  }



  render = () => (
    <div className="print-container">
      <ToastContainer />
      <title>React App</title>
      {this.state.loading > 0 && (
        <div id="overlay">
          =
          <Spinner
            className="spinner-centre"
            size={120}
            color={"#3273dc"}
            stroke={5}
            visible={this.state.loading > 0}
          />
        </div>
      )}
      <Section>
        <Container className="custom-container" fluid>
          <BrowserRouter>
            <ErrorBoundary><Routes>

              <Route path={""} element={<PrivateRoute/>}>
                <Route path={"/"} element={<Home {...routeProps}/>}/>
                <Route path="/editvehicle/:vehicle?" element={<VehicleForm {...routeProps}/>} />
                <Route path="/vehicles/" element={<Vehicles {...routeProps}/>} />
                <Route path="/keys/" element={<KeyFinder {...routeProps}/>}/>
                <Route path="/accountbalance/" element={<ContactsAccountBalance {...routeProps}/>}/>
                <Route path={"/editjob/:job?"} element={<JobForm {...routeProps}/>}/>
                <Route path="/detailWorkLookup/:workLookup?" element={<WorkLookupForm {...routeProps}/>}/>
                <Route path="/defect/:job?" element={<DefectForm {...routeProps}/>}/>
                <Route path="/partenquiry" element={<PartEnquiryForm {...routeProps}/>}/>
                <Route path="/jobs/" element={<Jobs {...routeProps}/>}/>
                <Route path="/quotes/" element={<Quotes {...routeProps}/>}/>
                <Route path={"/editquote/:quote?"} element={<QuoteForm {...routeProps}/>}/>
                <Route path="/parts/" element={<PartView {...routeProps}/>}/>
                <Route path="/partHistory/" element={<PartHistory {...routeProps}/>}/>
                <Route path="/partLookup/" element={<PartLookup {...routeProps}/>}/>
                <Route path="/workLookup/" element={<WorkLookup {...routeProps}/>}/>
                <Route path={"/partorders/"} element={<PartOrderView {...routeProps}/>}/>
                <Route path="/editpartorder/:partorder?" element={<PartOrderForm {...routeProps}/>}/>
                <Route path="/invoicing/" element={<InvoicePOView {...routeProps} view={"invoice"}/>}/>
                <Route path="/po/" element={<InvoicePOView {...routeProps} view={"po"}/>}/>
                <Route path="/income/" element={<Transactions {...routeProps}/>}/>
                <Route path="/expenses/" element={<Transactions {...routeProps}/>}/>
                <Route path={"/fixedexpense"} element={<FixedExpense {...routeProps}/>}/>
                <Route path={"/vanpartsexpenses"} element={<VanPartsExpenses {...routeProps}/>}/>
                <Route path={"/labelprinter"} element={<LabelPrinterPage {...routeProps}/>}/>
                <Route path={"/vanpartsincome"} element={<VanPartsIncome {...routeProps}/>}/>
                <Route path={"/editrental/:rental?"} element={<RentalForm {...routeProps}/>}/>
                <Route path="/rentals" element={<Rentals {...routeProps}/>}/>
                <Route path="/editcontact/:contact?" element={<Contact {...routeProps}/>}/>
                <Route path="/contacts/" element={<Contacts {...routeProps}/>}/>
                <Route path="/inspections/" element={<Inspection {...routeProps}/>}/>
                <Route path="/payments/" element={<Payment {...routeProps}/>}/>
                <Route path="/recurringpayments/" element={<RecurringPayment {...routeProps}/>}/>
                <Route path="/diary/" element={<Diary {...routeProps}/>}/>
                <Route path={"/printrental/:rental"} element={<RentalPrintView {...routeProps}/>}/>
                <Route path={"/reports"} element={<Reports {...routeProps}/>}/>
                <Route path="/settings" element={<Settings {...routeProps}/>}/>
                <Route path="/trackers/" element={<VehicleTrackers {...routeProps}/>}/>
                <Route path="/movements" element={<MovementView {...routeProps}/>}/>
                <Route path="/editmovement/:movement" element={<MovementForm {...routeProps}/>}/>
                <Route path="/invoices" element={<InvoiceView {...routeProps}/>}/>
                <Route path={"/credit"} element={<CreditView {...routeProps}/>}/>
                <Route path={"/alllinks"} element={<AllDropDownLinks {...routeProps}/>}/>
              </Route>
            {/*<PrivateRoute exact path={"/alllinks"} component={AllDropDownLinks}/>*/}
            <Route path={"/login"} element={<GoogleLoginButton {...routeProps} />}/>

            </Routes></ErrorBoundary>
          </BrowserRouter>
        </Container>
      </Section>
    </div>
  );
}
